import axios from 'axios';
import { ProductCardData } from '../../ProductList/type';
import type { CreatorTypeS } from '../../Creator/outbound/share';
import { MyPageConstantS } from '../outbound/share';

/**
 * @param refresh - 디스크 캐시를 피하기 위한 프로퍼티
 */
export const getRecentlyViewProductsApi = async ({
  refresh,
  limit,
}: { refresh?: boolean; limit?: number } = {}): Promise<ProductCardData[]> => {
  const { data } = await axios.get<ProductCardData[]>(`/${T.lang}/@api/mypage/recent/products`, {
    params: {
      timestamp: refresh ? Date.now() : '',
      limit: limit ?? MyPageConstantS.RECENT_CACHE_STORE_PRODUCT_OPTION.limit,
    },
  });

  return data;
};

export const getRecentlyViewCreatorsApi = async ({ refresh }: { refresh?: boolean } = {}): Promise<
  CreatorTypeS.CreatorCardType[]
> => {
  const { data } = await axios.get<CreatorTypeS.CreatorCardType[]>(`/${T.lang}/@api/mypage/recent/creators`, {
    params: {
      timestamp: refresh ? Date.now() : '',
    },
  });

  return data;
};
